import { create } from 'zustand'
import { ChapterItem } from '../types/chapters'

interface ChapterStore {
  dataList: ChapterItem[]
  isLoading: boolean
  error: string | null
  setDataList: (data: ChapterItem[]) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clearError: () => void
}

export const useChapterStore = create<ChapterStore>((set, get) => ({
  dataList: [],
  isLoading: false,
  error: null,

  setDataList: (data) => set({ dataList: data }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
}))
